function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import Backbone from '@polleverywhere/backbone';
/*
 * Encapsulates JSON API
 *
 * It's pretty barebones right now. But it will be populated
 * with more logic to parse JSON API data as we implement more
 * on the backend.
 *
 * @namespace Model
 *
 */

var JsonAPI = /*#__PURE__*/function (_Backbone$Model) {
  _inheritsLoose(JsonAPI, _Backbone$Model);

  function JsonAPI() {
    return _Backbone$Model.apply(this, arguments) || this;
  }

  var _proto = JsonAPI.prototype;
  /*
   * Retrieve meta information
   * @param [String] key Meta information key
   * @return [Object]
   */

  _proto.meta = function meta(key) {
    return this.get('meta')[key];
  }
  /*
   * Retrieve links information
   *
   * @param [String] key Link data key
   * @return [Object] String URL or link object
   *
   */
  ;

  _proto.links = function links(key) {
    return this.get('links')[key];
  }
  /*
   * Retrieve data payload
   *
   */
  ;

  _proto.data = function data() {
    return this.get('data');
  };

  return JsonAPI;
}(Backbone.Model);

export { JsonAPI as default };